import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.some.js";
import $router from '@/router';
export const isSameRoute = (current, reference) => {
  // return current.fullPath === reference.fullPath && JSON.stringify(current.params) === JSON.stringify(reference.params)
  return current.fullPath === reference.fullPath;
};
export default {
  namespaced: true,
  state: () => ({
    visitedViews: [],
    cachedViews: [],
    dateRandom: null,
    qyStatus: ''
  }),
  mutations: {
    ADD_VISITED_VIEW(state, view) {
      if (state.visitedViews.some(v => isSameRoute(v, view))) return;
      state.visitedViews.push(Object.assign({}, view, {
        title: view.meta && view.meta.title || 'no-name'
      }));
    },
    ADD_CACHED_VIEW(state, view) {
      if (view.name === null) return;
      if (view.meta?.detail) return;
      if (state.cachedViews.includes(view.fullPath)) return;
      if (!view.meta || view.meta && !view.meta.noCache) {
        state.cachedViews.push(view.fullPath);
      }
    },
    DEL_VISITED_VIEW(state, view) {
      for (const [i, v] of state.visitedViews.entries()) {
        if (isSameRoute(v, view)) {
          state.visitedViews.splice(i, 1);
          break;
        }
      }
    },
    DEL_CACHED_VIEW(state, view) {
      if (view.name === null) return;
      const index = state.cachedViews.indexOf(view.fullPath);
      index > -1 && state.cachedViews.splice(index, 1);
    },
    DEL_OTHERS_VISITED_VIEWS(state, view) {
      state.visitedViews = state.visitedViews.filter(v => {
        return v.meta && v.meta.affix || isSameRoute(v, view);
      });
    },
    DEL_OTHERS_CACHED_VIEWS(state, view) {
      if (view.name === null) return;
      const index = state.cachedViews.indexOf(view.fullPath);
      if (index > -1) {
        state.cachedViews = state.cachedViews.slice(index, index + 1);
      } else {
        // if index = -1, there is no cached tags
        state.cachedViews = [];
      }
    },
    DEL_ALL_VISITED_VIEWS(state) {
      // keep affix tags
      const affixTags = state.visitedViews.filter(tag => tag.meta && tag.meta.affix);
      state.visitedViews = affixTags;
    },
    DEL_ALL_CACHED_VIEWS(state) {
      state.cachedViews = [];
    },
    UPDATE_VISITED_VIEW(state, view) {
      for (let v of state.visitedViews) {
        if (isSameRoute(v, view)) {
          v = Object.assign(v, view);
          break;
        }
      }
    },
    // 个性化修改 tagView title
    SET_VISITED_TAGS_VIEW_TITLE(state, payload = {}) {
      const path = payload.path || $router.currentRoute.value.path;
      const target = state.visitedViews.find(page => page.path === path);
      target.custom = payload;
    },
    SET_DATE_RANDOM(state, val) {
      state.dateRandom = val;
    },
    SET_QYSTATUS(state, val) {
      state.qyStatus = val;
    }
  },
  actions: {
    addView({
      commit
    }, view) {
      if (view.matched && view.matched.length === 3) {
        const parentView = view.matched[1];
        commit('ADD_CACHED_VIEW', parentView);
      }
      commit('ADD_VISITED_VIEW', view);
      commit('ADD_CACHED_VIEW', view);
    },
    addVisitedView({
      commit
    }, view) {
      commit('ADD_VISITED_VIEW', view);
    },
    delView({
      commit
    }, view) {
      if (view.name === 'supplierPurchaseOrder') {
        commit('SET_DATE_RANDOM', null);
      }
      commit('DEL_VISITED_VIEW', view);
      commit('DEL_CACHED_VIEW', view);
    },
    delCachedView({
      commit
    }, view) {
      commit('DEL_CACHED_VIEW', view);
    },
    delOthersViews({
      commit
    }, view) {
      commit('DEL_OTHERS_VISITED_VIEWS', view);
      commit('DEL_OTHERS_CACHED_VIEWS', view);
    },
    delAllViews({
      commit
    }) {
      commit('DEL_ALL_VISITED_VIEWS');
      commit('DEL_ALL_CACHED_VIEWS');
    },
    delAllCachedViews({
      commit
    }) {
      commit('DEL_ALL_CACHED_VIEWS');
    },
    updateVisitedView({
      commit
    }, view) {
      commit('UPDATE_VISITED_VIEW', view);
    },
    setDateRandom({
      commit
    }, val) {
      commit('SET_DATE_RANDOM', val);
    },
    setQystatus({
      commit
    }, val) {
      commit('SET_QYSTATUS', val);
    }
  }
};